import Svg, { SvgProps, Path } from 'react-native-svg';
import { memo } from 'react';
const SvgComponent = (props: SvgProps) => (
  <Svg viewBox="0 0 36 36" {...props}>
    <Path d="M0 36 18 0l18 36z" />
  </Svg>
);
const Memo = memo(SvgComponent);
export default Memo;
